import RouterFactory from '@trax/classes/RouterFactory'

// Layout.
import FullPageLayout from './layout/FullPageLayout.vue';
import SideMenuLayout from './layout/SideMenuLayout.vue';

// General Views.
import LoginPage from './pages/LoginPage.vue';
import NotFoundPage from './pages/NotFoundPage.vue';
import UnauthorizedPage from './pages/UnauthorizedPage.vue';
import MaintenancePage from './pages/MaintenancePage.vue';
import ErrorPage from './pages/ErrorPage.vue';

// Accounts views.
import OwnersPage from './pages/accounts/OwnersPage.vue';
import UsersCrudPage from './pages/accounts/UsersCrudPage.vue';
import AgentsCrudPage from './pages/accounts/AgentsCrudPage.vue';
import RolesCrudPage from './pages/accounts/RolesCrudPage.vue';
import ClientsCrudPage from './pages/accounts/ClientsCrudPage.vue';
import AccessesCrudPage from './pages/accounts/AccessesCrudPage.vue';
import EntitiesCrudPage from './pages/accounts/EntitiesCrudPage.vue';

// Monitoring views.
import LogsPage from './pages/monitoring/LogsPage.vue';

// Data views.
import StatementsPage from './pages/data/StatementsPage.vue';
import AgentsPage from './pages/data/AgentsPage.vue';
import ActivitiesPage from './pages/data/ActivitiesPage.vue';
import AgentProfilesPage from './pages/data/AgentProfilesPage.vue';
import ActivityProfilesPage from './pages/data/ActivityProfilesPage.vue';
import StatesPage from './pages/data/StatesPage.vue';

// Vocab views.
import VerbsPage from './pages/vocab/VerbsPage.vue';
import ActivityTypesPage from './pages/vocab/ActivityTypesPage.vue';
import StatementCategoriesPage from './pages/vocab/StatementCategoriesPage.vue';

// Settings views.
import ManagementPage from './pages/settings/ManagementPage.vue';

// Privacy views.
import MyAccountPage from './pages/privacy/MyAccountPage.vue';
import MyAgentsPage from './pages/privacy/MyAgentsPage.vue';
import MyStatementsPage from './pages/privacy/MyStatementsPage.vue';
import MyProfilesPage from './pages/privacy/MyProfilesPage.vue';
import MyStatesPage from './pages/privacy/MyStatesPage.vue';
import MyEndpointPage from './pages/privacy/MyEndpointPage.vue';


function getRoutes(auth) {

    // Used for local permissions implementation.
    const permissions = Vue.prototype.$permissions

    return [
        {
            path: "/xlrs",
            redirect: "/xlrs/login",
            component: FullPageLayout,
            children: [
                {
                    path: "login",
                    name: "login",
                    beforeEnter: auth.ifNotAuthenticated,
                    component: LoginPage
                },
                {
                    path: "owners",
                    name: "owners",
                    beforeEnter: auth.ifHasNoOwner,
                    component: OwnersPage
                },
            ]
        },
        {
            path: "/xlrs",
            component: SideMenuLayout,
            children: [
                {
                    path: "home",
                    name: "home",
                    beforeEnter: permissions.redirectToHome,
                    component: StatementsPage
                },
                {
                    path: "my-account",
                    name: "my-account",
                    beforeEnter: auth.ifAuthenticated,
                    component: MyAccountPage
                },
            ]
        },
        {
            path: "/xlrs/monitoring",
            component: SideMenuLayout,
            children: [
                {
                    path: "logs",
                    name: "logs",
                    beforeEnter: (to, from, next) => {
                        auth.ifHasOnePermission(['xapi-extra.manage', 'xapi-extra.observe'], to, from, next)
                    },
                    component: LogsPage
                },
            ]
        },
        {
            path: "/xlrs/accounts",
            component: SideMenuLayout,
            children: [
                {
                    path: "users",
                    name: "users",
                    beforeEnter: (to, from, next) => {
                        auth.ifHasPermission('user.manage', to, from, next)
                    },
                    component: UsersCrudPage
                },
                {
                    path: "users/:id/agents",
                    name: "user-agents",
                    beforeEnter: (to, from, next) => {
                        auth.ifHasPermission('user.manage', to, from, next)
                    },
                    component: AgentsCrudPage
                },
                {
                    path: "roles",
                    name: "roles",
                    beforeEnter: (to, from, next) => {
                        auth.ifHasPermission('role.manage', to, from, next)
                    },
                    component: RolesCrudPage
                },
                {
                    path: "clients",
                    name: "clients",
                    beforeEnter: (to, from, next) => {
                        auth.ifHasPermission('client.manage', to, from, next)
                    },
                    component: ClientsCrudPage
                },
                {
                    path: "clients/:id/accesses",
                    name: "accesses",
                    beforeEnter: (to, from, next) => {
                        auth.ifHasPermission('client.manage', to, from, next)
                    },
                    component: AccessesCrudPage
                },
                {
                    path: "entities",
                    name: "entities",
                    beforeEnter: (to, from, next) => {
                        auth.ifHasPermission('entity.manage', to, from, next)
                    },
                    component: EntitiesCrudPage
                },
            ]
        },
        {
            path: "/xlrs/xapi",
            component: SideMenuLayout,
            children: [
                {
                    path: "statements",
                    name: "statements",
                    beforeEnter: (to, from, next) => {
                        auth.ifHasOnePermission(['xapi-extra.manage', 'xapi-extra.observe'], to, from, next)
                    },
                    component: StatementsPage
                },
                {
                    path: "agents",
                    name: "agents",
                    beforeEnter: (to, from, next) => {
                        auth.ifHasOnePermission(['xapi-extra.manage', 'xapi-extra.observe'], to, from, next)
                    },
                    component: AgentsPage
                },
                {
                    path: "activities",
                    name: "activities",
                    beforeEnter: (to, from, next) => {
                        auth.ifHasOnePermission(['xapi-extra.manage', 'xapi-extra.observe'], to, from, next)
                    },
                    component: ActivitiesPage
                },
                {
                    path: "agent-profiles",
                    name: "agent-profiles",
                    beforeEnter: (to, from, next) => {
                        auth.ifHasOnePermission(['xapi-extra.manage', 'xapi-extra.observe'], to, from, next)
                    },
                    component: AgentProfilesPage
                },
                {
                    path: "activity-profiles",
                    name: "activity-profiles",
                    beforeEnter: (to, from, next) => {
                        auth.ifHasOnePermission(['xapi-extra.manage', 'xapi-extra.observe'], to, from, next)
                    },
                    component: ActivityProfilesPage
                },
                {
                    path: "states",
                    name: "states",
                    beforeEnter: (to, from, next) => {
                        auth.ifHasOnePermission(['xapi-extra.manage', 'xapi-extra.observe'], to, from, next)
                    },
                    component: StatesPage
                },
                {
                    path: "verbs",
                    name: "verbs",
                    beforeEnter: (to, from, next) => {
                        auth.ifHasOnePermission(['xapi-extra.manage', 'xapi-extra.observe'], to, from, next)
                    },
                    component: VerbsPage
                },
                {
                    path: "activity-types",
                    name: "activity-types",
                    beforeEnter: (to, from, next) => {
                        auth.ifHasOnePermission(['xapi-extra.manage', 'xapi-extra.observe'], to, from, next)
                    },
                    component: ActivityTypesPage
                },
                {
                    path: "statement-categories",
                    name: "statement-categories",
                    beforeEnter: (to, from, next) => {
                        auth.ifHasOnePermission(['xapi-extra.manage', 'xapi-extra.observe'], to, from, next)
                    },
                    component: StatementCategoriesPage
                },
                {
                    path: "management",
                    name: "management",
                    beforeEnter: (to, from, next) => {
                        auth.ifHasPermission('xapi-extra.manage', to, from, next)
                    },
                    component: ManagementPage
                },
                {
                    path: "my-agents",
                    name: "my-agents",
                    beforeEnter: auth.ifAuthenticated,
                    component: MyAgentsPage
                },
                {
                    path: "my-statements",
                    name: "my-statements",
                    beforeEnter: auth.ifAuthenticated,
                    component: MyStatementsPage
                },
                {
                    path: "my-profiles",
                    name: "my-profiles",
                    beforeEnter: auth.ifAuthenticated,
                    component: MyProfilesPage
                },
                {
                    path: "my-states",
                    name: "my-states",
                    beforeEnter: auth.ifAuthenticated,
                    component: MyStatesPage
                },
                {
                    path: "my-endpoint",
                    name: "my-endpoint",
                    beforeEnter: auth.ifAuthenticated,
                    component: MyEndpointPage
                },
            ]
        },
        {
            path: "/xlrs",
            component: FullPageLayout,
            children: [
                {
                    path: "unauthorized",
                    name: "unauthorized",
                    component: UnauthorizedPage,
                },
                {
                    path: "maintenance",
                    name: "maintenance",
                    component: MaintenancePage,
                },
                {
                    path: "error",
                    name: "error",
                    component: ErrorPage,
                },
                {
                    path: "*",
                    name: "unknown",
                    component: NotFoundPage,
                },
            ]
        },
    ]
}

export default {

    routes() {
        return getRoutes(Vue.prototype.$auth)
    },

    router() {
        return RouterFactory.make(this.routes())
    },
}

